import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  full_name: string | null;
  job_title: string | null;
  company: string | null;
  bio: string | null;
  linkedin_url: string | null;
  avatar_url: string | null;
  organization_id: string | null;
  timezone: string;
  language: string;
  onboarding_completed: boolean;
  created_at: string;
  updated_at: string;
};

export type FeedbackRequest = {
  id: string;
  requester_id: string;
  recipient_email: string;
  recipient_name: string | null;
  unique_link: string;
  status: 'pending' | 'completed' | 'expired';
  message: string | null;
  organization_id: string | null;
  category: string | null;
  is_anonymous: boolean;
  reminder_sent_count: number;
  last_reminder_sent_at: string | null;
  expires_at: string;
  completed_at: string | null;
  created_at: string;
};

export type FeedbackResponse = {
  id: string;
  request_id: string;
  audio_url: string | null;
  transcription: string | null;
  raw_feedback: string | null;
  duration_seconds: number;
  processing_status: string;
  processed_at: string | null;
  transcription_service: string | null;
  sentiment_score: number | null;
  created_at: string;
};

export type FeedbackSummary = {
  id: string;
  user_id: string;
  strengths: Array<{ name: string; score: number; description: string }>;
  themes: Array<{ name: string; frequency: number; examples: string[] }>;
  development_areas: Array<{ area: string; suggestion: string }>;
  ai_summary: string | null;
  total_responses: number;
  last_processed_at: string | null;
  created_at: string;
  updated_at: string;
};

export type QuestionTemplate = {
  id: string;
  role: 'Founder' | 'Manager' | 'IC' | 'Any';
  category: string;
  question_text: string;
  is_default: boolean;
  active: boolean;
  ordering: number;
  created_at: string;
  updated_at: string;
};

export type QuestionSelectionLog = {
  id: string;
  user_id: string | null;
  request_id: string | null;
  question_source: 'template' | 'ai' | 'custom';
  question_text: string;
  selected: boolean;
  role: string | null;
  category: string | null;
  created_at: string;
};
